import React from "react";
import { FiX, FiMinus, FiSquare, FiTerminal } from "react-icons/fi";

const SECTION_TABS = {
  home: { name: "hero.tsx", path: "#home" },
  about: { name: "about_me.js", path: "#about" },
  education: { name: "education.log", path: "#education" },
  experience: { name: "experience.js", path: "#experience" },
  projects: { name: "projects.py", path: "#projects" },
  hackathons: { name: "hackathons.sh", path: "#hackathons" },
  leadership: { name: "leadership.md", path: "#extracurricular" },
  "beyond-tech": { name: "beyond_tech.json", path: "#beyond-tech" },
  resume: { name: "resume.pdf", path: "#resume" },
};

function TabWindow({
  activeTabId = "home",
  activeFileName = "hero.tsx",
  language = "TYPESCRIPT",
  children,
  className = "",
}) {
  const currentTab = SECTION_TABS[activeTabId] || { name: activeFileName, path: "#" };

  return (
    <div className={`computer-tab-window ${className}`}>
      {/* Minimal Clean Window Titlebar */}
      <div className="tab-window-titlebar">
        {/* Window Control Buttons */}
        <div className="window-controls">
          <span className="window-btn btn-close"><FiX size={9} /></span>
          <span className="window-btn btn-minimize"><FiMinus size={9} /></span>
          <span className="window-btn btn-maximize"><FiSquare size={8} /></span>
        </div>

        {/* Clean Active File Tab */}
        <div className="tab-items-container">
          <div className="tab-item active">
            <span className="tab-name">{currentTab.name}</span>
            <span className="tab-close-dot">×</span>
          </div>
        </div>

        {/* Right Status Badge */}
        <div className="window-right-status">
          <span className="status-badge">khushbu@dev-os</span>
        </div>
      </div>

      {/* Main Computer Window Body */}
      <div className="tab-window-body">
        {children}
      </div>

      {/* Minimal Status Bar */}
      <div className="tab-window-statusbar">
        <div className="statusbar-left">
          <span className="status-item"><FiTerminal /> MAIN*</span>
          <span className="status-item">UTF-8</span>
          <span className="status-item">{language}</span>
        </div>
        <div className="statusbar-right">
          <span className="status-item">LN 1, COL 1</span>
          <span className="status-item status-ok">● READY</span>
        </div>
      </div>
    </div>
  );
}

export default TabWindow;
